import { createFileRoute } from '@tanstack/react-router';
import { SecurityStatement } from '@/components/legal';

// Public route - no auth required
export const Route = createFileRoute('/security')({
  component: SecurityStatement,
});
